import React, { useEffect, useMemo, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload
} from "@fortawesome/free-solid-svg-icons";
import classes from './SinglePDF.module.css';


pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const SinglePDF = (props: any) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }: any) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    function changePage(offset: any) {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    function previousPage() {
        changePage(-1);
    }

    function nextPage() {
        changePage(1);
    }

    const { pdf } = props;

    return (
        <div>
            <Document className={classes.pdfDocument} file={pdf} loading="Načítám PDF" options={{ workerSrc: "/pdf.worker.js" }}
                onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} renderAnnotationLayer={false} renderTextLayer={false} />
            </Document>
            <div className={classes.content}>
                <p>
                    Strana {pageNumber || (numPages ? 1 : "--")} z {numPages || "--"}
                </p>
                <div className={classes.button}>
                    <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
                        Předchozí
                    </button>
                    <button
                        type="button"
                        disabled={pageNumber >= (numPages ? numPages : 0)}
                        onClick={nextPage}
                    >
                        Další
                    </button>
                    <a href={pdf} download><button>Stáhnout <FontAwesomeIcon icon={faDownload} /></button></a>
                </div>

            </div>
        </div>

    );
}

export default SinglePDF;